import { useEffect } from "react";
import "./index.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Root from "./common/layout/root.view";
import Login from "./common/auth/containers/login";
import Logout from "./common/auth/containers/logout";
import Landing from "./landing/landing";
import PrivateRoute from "./common/auth/containers/privateRoute";
import { createBrowserHistory } from "history";
import InboxPage from "./Pages/Inbox/InboxPage";
import EstatePage from "./Pages/Estates/EstatePage";
import InvoicePage from "./Pages/Invoice/InvoicePage";
import PropertyTaxPage from "./Pages/PropertyTax/PropertyTaxPage";
import UserProfilePage from "./Pages/UserProfile/UserProfilePage";
import { BootstrapSpinner } from "./common/spinners/bootstrapSpinner";
import { useMunicipality } from "./Contexts/MunicipalityKey";
import { useAppDispatch, useAppSelector } from "./Hooks";
import WaterMeterPage from "./Pages/WaterMeter/WaterMeterPage";
import { useGetRolesQuery } from "./Requests/roleApiSlice";
import { rolesLoaded, rolesLoading } from "./common/roleChooser/roleChooserSlice";
import { useConfigDataQuery } from "./Requests/configApi";
import { configLoaded, configLoading } from "./common/config/configSlice";

const App = () => {
  let history = createBrowserHistory();
  const municipality = useMunicipality();
  const dispatch = useAppDispatch();
  const auth = useAppSelector(state => state.auth);

  const { data: roles, isFetching: loadingRoles, error: rolesError} = useGetRolesQuery(municipality.name);
  const { data: config, isFetching: loadingConfig, error: configError } = useConfigDataQuery(municipality.name);

  useEffect(() => {

    if (!!auth?.user?.profile.pid) {
      if (!config && !configError && !loadingConfig) {
        dispatch(configLoading());
      }

      if (config) {
        dispatch(configLoaded(config));
      }

      if(loadingRoles) {
        dispatch(rolesLoading());
      }

      if(roles){
        dispatch(rolesLoaded(roles));
      }
    }
  }, [auth.user?.profile.pid, config, loadingConfig, configError, roles, loadingRoles, rolesError, auth?.user?.access_token, auth.error, auth.loading, auth.error]);

  if(loadingConfig)
  {   
    return <BootstrapSpinner />
  }

  return (
    <Router>
      <Routes>
        <Route element={<Root />}>
          {/* <Route path="/" element={<Landing />} /> */}
          <Route path={"/"} element={<PrivateRoute />}>
            <Route path="/" element={<Landing />} />
          </Route>
          <Route path={"/profil"} element={<PrivateRoute />}>
            <Route path="/profil" element={<UserProfilePage />} />
          </Route>
          <Route path={"/eiendommer/*"} element={<PrivateRoute />}>
            <Route
              path="/eiendommer/*"
              element={<EstatePage />}/>
          </Route>
          <Route path={"/eiendomsskatt"} element={<PrivateRoute />}>
            <Route path="/eiendomsskatt" element={<PropertyTaxPage />} />
          </Route>
          <Route path={"/post-fra-kommunen"} element={<PrivateRoute />}>
            <Route path="/post-fra-kommunen" element={<InboxPage />} />
          </Route>
          <Route path={"/faktura"} element={<PrivateRoute />}>
            <Route path="/faktura" element={<InvoicePage />} />
          </Route>
          <Route path={"/vann"} element={<PrivateRoute />}>
            <Route path="/vann" element={<WaterMeterPage />} />
          </Route>
          <Route path={"/login/*"} element={<Login myLocation={history} />} />
          <Route path={"/logout/*"} element={<Logout />} />
        </Route>
      </Routes>
    </Router>
  )
};

export default App;